// removed by extract-text-webpack-plugin
module.exports = {"commodities":"_1bDN8EsDqQDUxf_seZmD8Q","additionalCheckboxes":"_1k6le5xSiUaWHcqUhJL1uV","additionalFilterWrapper":"_2bTw23IkKLWVgjRquGciQ4","wrapper":"_3IhAlhVyu1zCJS6fNJq8l4","imgWrapper":"XIwRcBggeVIfrtBrKJjlg","commoditiesWrapper":"_1u1kXhzmM6o2rJmkllpb7y","bathToiletsRowWrapper":"_3bdf-Hj26ENDUzn-iCboxt","selectWrapper":"oq7R7DdMHfNn8t_cmMMc2","titleWrapper":"A7gTpSfoOhhSD-Nuud3Oy","bathToiletsWrapper":"_3PU__iPr9S1XpZNAHtZRUS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdditionalFilters/AdditionalFilters.scss
// module id = 1550
// module chunks = 0